module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"title": "Timeseries",
	"description": "Return value of the timeseries API.",
	"type": "object",
	"patternProperties": {
		".*": {
			"type": "object",
			"required": [],
			"properties": {
				"meta": {
					"type": "object",
					"required": [
						"id",
						"name"
					],
					"properties": {
						"id": {
							"type": "string"
						},
						"name": {
							"type": "string"
						}
					}
				},
				"ts": {
					"type": "array",
					"items": {
						"type": "array",
						"items": [
							{
								"type": "string"
							},
							{
								"type": "number"
							}
						]
					}
				}
			}
		}
	}
}